import { MessageCircle, Phone, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CONTACT } from "../data/content";

export const FloatingCTA = () => {
  const navigate = useNavigate();
  return (
    <>
      <motion.a
        data-testid="floating-whatsapp-btn"
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.6, type: "spring", stiffness: 200 }}
        className="fixed bottom-6 right-6 z-40 hidden md:grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/30 transition-transform duration-300 hover:scale-110"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <MessageCircle size={26} className="relative" />
      </motion.a>

      <div
        data-testid="mobile-sticky-cta"
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-white/10 bg-dg-navy/95 backdrop-blur-xl md:hidden"
      >
        <a
          data-testid="sticky-whatsapp"
          href={CONTACT.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 py-3.5 text-xs font-bold text-[#25D366]"
        >
          <MessageCircle size={16} /> WhatsApp
        </a>
        <a
          data-testid="sticky-call"
          href={CONTACT.phoneHref}
          className="flex items-center justify-center gap-2 border-x border-white/10 py-3.5 text-xs font-bold text-white"
        >
          <Phone size={16} /> Call
        </a>
        <button
          data-testid="sticky-quote"
          onClick={() => navigate("/contact")}
          className="flex items-center justify-center gap-2 bg-dg-cyan py-3.5 text-xs font-bold text-dg-navy"
        >
          <FileText size={16} /> Get Quote
        </button>
      </div>
    </>
  );
};
